import { getFilterContact } from '../services';
export const fetchFilterContact = () => getFilterContact().then(response => formatResponse(response?.data));
const formatResponse = (response) => ({
    data: Object.entries(response?.data ?? {}).map(([key, name]) => ({
        key,
        name,
    })),
    errors: response?.errors,
    success: response?.success,
});
